const my_profile = {
  viewMyClubSeacretProfile: "View My ClubSeacret Profile",
  viewMoreDetails: "View More Details",
  verifiedEmail: "Verified Email",
  unverifiedEmail: "Unverified Email",
  balance: "Balance",
  pointsIn: "Points In",
  pointsOut: "Points Out",
  topUp: "Top Up",
  pointsHistoryTable: "Points History Table",
  createdFrom: "Created From",
  createdTo: "Created To",
  selectStatus: "Select status...",
  searchByTitle: "Search by title...",
  offerStatus: "Offer Status",
  selectOfferStatus: "All",
  quotationSent: "Quotation Sent",
  offerInProgress: "Offer In Progress",
  offerAvailable: "Offer Available",
  offerAccepted: "Offer Accepted",
  offerExpired: "Offer Expired",
  pushNotifications: "Push Notifications",
  pushNotificationsDescription: "Receive browser notifications for important updates and events",
  pushNotificationsNotSupported: "Push notifications are not supported in this browser",
  pushNotificationsDeniedMessage: "Notification permission was denied. Please enable notifications in your browser settings to receive push notifications.",
  pushNotificationsEnabled: "Push notifications enabled successfully",
  pushNotificationsDisabled: "Push notifications disabled successfully",
  userInformationMissing: "User information is missing",
  failedToUpdatePushNotifications: "Failed to update push notification settings",
  notificationPermissionDenied: "Notification permission was denied. Please enable it in your browser settings.",
  notificationPermissionRequired: "Notification permission is required to enable push notifications",
  notSupported: "Not supported",
  permissionDenied: "Permission denied",
  permissionNotRequested: "Permission not requested",
  enabled: "Enabled",
  disabled: "Disabled",
};

export default my_profile;
